import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import CurrencyField from '../fields/CurrencyField';
import NavRow from '../fields/NavRow';
import { TaskDefinition, TaskStepRenderArgs } from '../QuestionnaireShell';
import { HourlyRateValues } from '../types';
import { currencyAmountSchema, zodResolver } from '../validation';

const schema = z.object({
  amount: currencyAmountSchema,
});

const DEFAULTS: HourlyRateValues = { amount: { display: '', value: 0 } };

const HourlyRateForm = ({ initialValues, onComplete, onBack, onCancelEdit, submitLabel }: TaskStepRenderArgs) => {
  const defaults = (initialValues as HourlyRateValues | undefined) ?? DEFAULTS;
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<HourlyRateValues>({
    defaultValues: defaults,
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit((values) => onComplete(values));

  return (
    <form className="rnq-form" onSubmit={(e) => e.preventDefault()}>
      <CurrencyField control={control} name="amount" label="Hourly Rate (USD)" required />
      <NavRow
        onBack={onBack}
        onCancelEdit={onCancelEdit}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        disabled={!isValid}
      />
    </form>
  );
};

const HourlyRate: TaskDefinition = {
  key: 'task8',
  label: 'Rate',
  title: 'What is your standard hourly rate?',
  render: (args) => <HourlyRateForm {...args} />,
};

export default HourlyRate;
